import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function AnimatedSection({
  children,
  className = '',
  id,
  delay = 0
}: AnimatedSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={`py-20 px-6 md:px-12 max-w-7xl mx-auto w-full ${className}`} data-id="element-16">
      {children}
    </motion.section>;
}